import { getProperties } from '../../services/userList'
import { useSentryQuery } from '../../utils/useSentryQuery'

export const useGetAllProperties = (
    params: Parameters<typeof getProperties>[0]['params'] & {
        isEnabled: boolean
    }
) => {
    return useSentryQuery({
        queryKey: ['getAllProperties'],
        queryFn: async ({ signal }) => getProperties({ params, signal }),
        enabled: params.isEnabled,
        staleTime: 1000 * 60 * 60, // 1Hour
    })
}
